module.exports = __webpack_public_path__ + "static/media/Alberth.cc1bd598.jpeg";